import { c as _c } from "react/compiler-runtime";
import { IconButton, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { VXButtons } from '../buttons/vxButtons';
export const RenameEntityName = t0 => {
  const $ = _c(17);
  const {
    name,
    label,
    onSubmit,
    bold: t1,
    editMode,
    setEditMode,
    focusOnMount: t2
  } = t0;
  const bold = t1 === undefined ? true : t1;
  const focusOnMount = t2 === undefined ? false : t2;
  const [internalEditMode, setInternalEditMode] = useState(editMode || focusOnMount);
  let t3;
  if ($[0] !== editMode || $[1] !== internalEditMode || $[2] !== setEditMode) {
    t3 = () => setEditMode ? editMode : internalEditMode;
    $[0] = editMode;
    $[1] = internalEditMode;
    $[2] = setEditMode;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getEditMode = t3;
  let t4;
  if ($[4] !== setEditMode) {
    t4 = editMode_0 => setEditMode ? setEditMode(editMode_0) : setInternalEditMode(editMode_0);
    $[4] = setEditMode;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const setEditModeWrapper = t4;
  let t5;
  if ($[6] !== label) {
    t5 = label && <Typography className="mr-[20px]">{label}</Typography>;
    $[6] = label;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== bold || $[9] !== getEditMode || $[10] !== name || $[11] !== onSubmit || $[12] !== setEditModeWrapper) {
    t6 = !getEditMode() ? <Stack direction="row" alignItems="center" gap="8px"><Typography className={bold ? "font-semibold" : ""}>{name}</Typography><IconButton onClick={() => setEditModeWrapper(true)} data-testid="rename-entity-name-edit-btn"><i className="material-symbols-stylus-outline w-[20px] h-[20px] text-(--mui-palette-text-primary)" /></IconButton></Stack> : <EditEntityName initialName={name} onSubmit={onSubmit} onClose={() => setEditModeWrapper(false)} />;
    $[8] = bold;
    $[9] = getEditMode;
    $[10] = name;
    $[11] = onSubmit;
    $[12] = setEditModeWrapper;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <Stack direction="row" alignItems="center" gap="4px">{t5}{t6}</Stack>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export const EditEntityName = t0 => {
  const $ = _c(23);
  const {
    initialName,
    onSubmit,
    onClose
  } = t0;
  const [newName, setNewName] = useState(initialName);
  let t1;
  if ($[0] !== newName) {
    t1 = validateName(newName);
    $[0] = newName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !t1;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      htmlInput: {
        "data-testid": "rename-entity-name-input"
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_0 => setNewName(e_0.target.value);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== newName || $[5] !== t2) {
    t5 = <TextField autoFocus={true} onFocus={_temp} error={t2} slotProps={t3} value={newName} onChange={t4} />;
    $[4] = newName;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== newName || $[8] !== onClose || $[9] !== onSubmit) {
    t6 = () => {
      onClose();
      onSubmit(newName);
    };
    $[7] = newName;
    $[8] = onClose;
    $[9] = onSubmit;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== initialName || $[12] !== onClose) {
    t7 = () => {
      onClose();
      setNewName(initialName);
    };
    $[11] = initialName;
    $[12] = onClose;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== newName) {
    t8 = validateName(newName);
    $[14] = newName;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = !t8;
  let t10;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t9) {
    t10 = <VXButtons onApprove={t6} onCancel={t7} approveDisabled={t9} />;
    $[16] = t6;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5) {
    t11 = <Stack direction="row" alignItems="center" gap="12px">{t5}{t10}</Stack>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
export const validateName = (name = '') => name.trim().length >= 4;
function _temp(e) {
  return e.target.select();
}